import { render, staticRenderFns } from "./bindRecord.vue?vue&type=template&id=7a28ffde&scoped=true&"
import script from "./bindRecord.vue?vue&type=script&lang=js&"
export * from "./bindRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a28ffde",
  null
  
)

export default component.exports